<template>
  <div class="_content" id="_content">
    <iframe
      width="100%"
      height="100%"
      frameborder="0"
      :src="src">
    </iframe>
  </div>
</template>
<script>
export default {
  data() {
    return {
      type: this.options.type
    }
  },
  computed: {
    src() {
      return 'https://imsdk.tuhu.cn/static/wap.html?' + this.toQueryString(this.type)
    }
  },
  created() {
    if (!this.type) {
      this.type = JSON.parse(localStorage.getItem('wapsdk'))
    }
  },
  methods: {
    toQueryPair(key, value) {
      if (typeof value === 'undefined') {
        return key
      }
      return key + '=' + encodeURIComponent(value === null ? '' : String(value))
    },
    toQueryString(obj) {
      var ret = []
      for (var key in obj) {
        key = encodeURIComponent(key)
        var values = obj[key]

        if (values && values.constructor === Array) { // 数组
          var queryValues = []
          for (var i = 0, len = values.length, value; i < len; i++) {
            value = values[i]
            queryValues.push(this.toQueryPair(key, value))
          }
          ret = ret.concat(queryValues)
        } else {
          ret.push(this.toQueryPair(key, values))
        }
      }
      return ret.join('&')
    }
  }
}
</script>
<style scoped>
._content {
  overflow: hidden;
  height: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
</style>



// WEBPACK FOOTER //
// lib/pages/_newcustomer/index.vue